<template>
  <div class="default-layout">
    <overlay v-if="overlayActive" />
    <loader />
    <div id="viewport" class="w-100 relative viewport-wrapper">
      <main-header />
      <div class="menu-top" v-if="!rootMain && !rootHome && !rootNameAllDiscounts && !isThankYouPage && !isPartnerPages && !isOrderPage">
        <main-menu />
      </div>

        <banners/>

      <async-sidebar
        :async-component="SearchPanel"
        :is-open="isSearchPanelOpen"
        @close="$store.commit('ui/setSearchpanel')"
        direction="bottom"
      />
      <async-sidebar
        :async-component="Microcart"
        :is-open="isMicrocartOpen"
        @close="$store.commit('ui/setMicrocart')"
      />
      <async-sidebar
        :async-component="SidebarMenu"
        :is-open="isSidebarOpen"
        @close="$store.commit('ui/setSidebar')"
        direction="left"
      />
      <slot />
      <main-footer />
      <notification />
      <sign-up />
      <age-popup />
      <cookie-notification />
      <offline-badge />
      <order-confirmation :orders-data="ordersData" v-if="loadOrderConfirmation" />
    </div>
    <vue-progress-bar />
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import AsyncSidebar from 'theme/components/theme/blocks/AsyncSidebar/AsyncSidebar.vue'
  import MainMenu from 'theme/components/core/blocks/Header/MainMenu.vue'
  import MainHeader from 'theme/components/core/blocks/Header/Header.vue'
  import MainFooter from 'theme/components/theme/blocks/Footer/Footer.vue'
  import Overlay from 'theme/components/core/Overlay.vue'
  import Loader from 'theme/components/core/Loader.vue'
  import Notification from 'theme/components/core/Notification.vue'
  import SignUp from 'theme/components/core/blocks/Auth/SignUp.vue'
  import AgePopup from 'theme/components/core/blocks/Category/AgeConfirmation.vue'
  import CookieNotification from 'theme/components/core/CookieNotification.vue'
  import OfflineBadge from 'theme/components/core/OfflineBadge.vue'
  import { isServer } from '@vue-storefront/core/helpers'
  import Head from 'theme/head'
  import config from 'config'
  import Banners from "../components/theme/blocks/Banners/Banners"

  const SidebarMenu = () => import(/* webpackPreload: true */ /* webpackChunkName: "vsf-sidebar-menu" */ 'theme/components/core/blocks/SidebarMenu/SidebarMenu.vue')
  const Microcart = () => import(/* webpackPreload: true */ /* webpackChunkName: "vsf-microcart" */ 'theme/components/core/blocks/Microcart/Microcart.vue')
  const SearchPanel = () => import(/* webpackChunkName: "vsf-search-panel" */ 'theme/components/core/blocks/SearchPanel/SearchPanel.vue')
  const OrderConfirmation = () => import(/* webpackChunkName: "vsf-order-confirmation" */ 'theme/components/core/blocks/Checkout/OrderConfirmation.vue')

  export default {
    data () {
      return {
        loadStoreModal: false,
        loadOrderConfirmation: false,
        ordersData: [],
        Microcart,
        SearchPanel,
        SidebarMenu
      }
    },
    computed: {
      ...mapState({
        overlayActive: state => state.ui.overlay,
        isSearchPanelOpen: state => state.ui.searchpanel,
        isSidebarOpen: state => state.ui.sidebar,
        isMicrocartOpen: state => state.ui.microcart,
      }),
      setRootName () {
        return this.$route.name
      },
      isOrderPage () {
        let myAccountLinks = ['my-order', 'my-orders', 'my-account', 'my-shipping-details', 'my-payment-details']
        return myAccountLinks.includes(this.$route.name)
      },
      rootHome () {
        return this.$route.name === 'selected-store'
      },
        rootMain () {
            return this.$route.name === 'home'
        },
      rootNameAllDiscounts () {
        return this.$route.name === 'allDiscounts'
      },
      isThankYouPage () {
        return this.$store.state.checkout.isThankYouPage ? this.$store.state.checkout.isThankYouPage : false
      },
      isPartnerPages () {
        if (this.currentPartner) {
          let url = '/' + this.currentPartner.location_code + '/' + this.currentPartner.code
          return this.$route.path === url
        }
        return false
      },
      ...mapGetters({
        currentPartner: 'partners/getCurrentPartner',
        currentLocation: 'locations/getActiveLocation'
      }),
    },
    methods: {
      onOrderConfirmation (payload) {
        this.loadOrderConfirmation = true
        this.ordersData = payload
        this.$bus.$emit('modal-show', 'modal-order-confirmation')
      },
      fetchMenuData () {
        return this.$store.dispatch('category/list', { level: config.entities.category.categoriesDynamicPrefetch && config.entities.category.categoriesDynamicPrefetchLevel >= 0 ? config.entities.category.categoriesDynamicPrefetchLevel : null, includeFields: config.entities.optimize && isServer ? config.entities.category.includeFields : null, skipCache: isServer })
      },
      goToStoredRoadAfterLogin () {
        if (localStorage.getItem('redirect')) {
          location.replace(localStorage.getItem('redirect'));
          localStorage.removeItem('redirect');
        }
      }
    },
    serverPrefetch () {
      if (this.$route.name === 'category') {
        return this.fetchMenuData()
      }
    },
    beforeMount () {
      // Progress bar on top of the page
      this.$router.beforeEach((to, from, next) => {
        this.$Progress.start()
        this.$Progress.increase(40)
        next()
      })
      this.$router.afterEach((to, from) => {
        this.$Progress.finish()
      })
      this.$bus.$on('offline-order-confirmation', this.onOrderConfirmation)
      this.$bus.$on('success-authenticate', this.goToStoredRoadAfterLogin)
    },
    beforeDestroy () {
      this.$bus.$off('offline-order-confirmation', this.onOrderConfirmation)
      this.$bus.$off('success-authenticate', this.goToStoredRoadAfterLogin)
    },
    metaInfo: Head,
    components: {
      MainMenu,
      MainHeader,
      MainFooter,
      SidebarMenu, // eslint-disable-line vue/no-unused-components
      Overlay,
      Loader,
      Notification,
      SignUp,
      AgePopup,
      CookieNotification,
      OfflineBadge,
      OrderConfirmation,
      AsyncSidebar,
      Banners
    }
  }
</script>

<style lang="scss" src="theme/css/main.scss"></style>
<style lang="scss" scoped>
  .viewport-wrapper {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }
</style>

<style lang="scss">
  ._wrapper {
    flex: 1 1 auto;
  }
</style>
